import { notificationsConstants } from '../constants/notifications';

export function notifications(state = { changelogCount: 0, changelogPanel: false }, action) {
    switch (action.type) {
        case notificationsConstants.GET_USER_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case notificationsConstants.GET_USER_NOTIFICATIONS_SUCCESS:
            return {

                ...state,
                loading: false,
                data: action.notifications.data,
                count: action.notifications.count,
            };
        case notificationsConstants.GET_USER_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case notificationsConstants.GET_STORE_PLAYLIST_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case notificationsConstants.GET_STORE_PLAYLIST_NOTIFICATIONS_SUCCESS:
            return {

                ...state,
                loading: false,
                playlist: action.notifications,
            };
        case notificationsConstants.GET_STORE_PLAYLIST_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case notificationsConstants.GET_HEARTBEATS_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                heartbeats: { updated: false }
            };
        case notificationsConstants.GET_HEARTBEATS_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                heartbeats: action.payload,
            };
        case notificationsConstants.GET_HEARTBEATS_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case notificationsConstants.UPDATE_STORE_PLAYLIST_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case notificationsConstants.UPDATE_STORE_PLAYLIST_NOTIFICATIONS_SUCCESS:
            return {

                ...state,
                loading: false,
                // playlistCount: action.notifications,
            };
        case notificationsConstants.UPDATE_STORE_PLAYLIST_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case notificationsConstants.GET_RELEASES_NOTIFICATIONS_REQUEST:
            return {
              ...state,
              loading: true,
              releases: { updated: false }
            };
        case notificationsConstants.GET_RELEASES_NOTIFICATIONS_SUCCESS:
            return {
              ...state,
              loading: false,
              releases: action.payload
            };
        case notificationsConstants.GET_RELEASES_NOTIFICATIONS_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.payload
            };
        case notificationsConstants.GET_COUNT_OF_NOTIFICATIONS_REQUEST:
            return {
              ...state,
              loading: true
            };
        case notificationsConstants.GET_COUNT_OF_NOTIFICATIONS_SUCCESS:
            return {
              ...state,
              loading: false,
              count: action.payload
            };
        case notificationsConstants.GET_COUNT_OF_NOTIFICATIONS_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.error
            };
        case notificationsConstants.UPDATE_RELEASE_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case notificationsConstants.UPDATE_RELEASE_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                releases: { updated: true }
            };
        case notificationsConstants.UPDATE_RELEASE_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                releases: { updated: false }
            };
        case notificationsConstants.UPDATE_HEARTBEATS_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case notificationsConstants.UPDATE_HEARTBEATS_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                heartbeats: { updated: true }
            };
        case notificationsConstants.UPDATE_HEARTBEATS_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                heartbeats: { updated: false }
            };
        case notificationsConstants.GET_ADMIN_NOTIFICATIONS_REQUEST:
            return {
              ...state,
              adminLoading: true,
              adminNotifications: null
            };
        case notificationsConstants.GET_ADMIN_NOTIFICATIONS_SUCCESS:
            return {
              ...state,
              adminLoading: false,
              adminNotifications: action.payload
            };
        case notificationsConstants.GET_ADMIN_NOTIFICATIONS_FAILURE:
            return {
              ...state,
              adminLoading: false,
              error: action.payload
            };
            
        case notificationsConstants.GET_CHANGELOG_REQUEST:
            return {
              ...state,
              changelogLoading: true,
              changelog: null
            };
        case notificationsConstants.GET_CHANGELOG_SUCCESS:
            return {
              ...state,
              changelogLoading: false,
              changelog: action.items,
              changelogCount: action.count !== undefined ? action.count : state.changelogCount
            };
        case notificationsConstants.GET_CHANGELOG_FAILURE:
            return {
              ...state,
              changelogLoading: false,
              error: action.payload
            };
        case notificationsConstants.SET_CHANGELOG_PANEL:
            return {
                ...state,
                changelogPanel: action.toggle,
                changelogCount: 0
            };
            
        default:
            return state
    }
}
